<template>
  <nav
    ref="characterSheetNavBar"
    class="navbar-expand-lg bb-navbar p-2 px-4"
  >
    <div class="d-flex align-items-end mb-2">
      <!-- LOGO -->
      <img src="/bbLogo64Blue.png" />
      <router-link
        class="navbar-brand px-3 mb-1"
        :to="{ name: 'campaignsView' }"
      >
        <span class="fw-lighter bb-app-heading">BATTLEBOARD</span>
        <!-- <span class="px-5" style="color: #737373"> {{ arena_name }}</span> -->
      </router-link>

      <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav ms-auto mt-2 align-items-end">
          <li class="nav-item dropdown me-3 mt-3">
            <button
              ref="menuToggle"
              class="btn dropdown-toggle btn-dark"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="resetSubmenus"
            >
              {{ userName }}
            </button>
            <ul class="dropdown-menu dropdown-menu-dark mt-0">
              <li>
                <router-link
                  class="dropdown-item"
                  :to="houseRulesTarget"
                  @click="handleMenuAction"
                >
                  House Rules
                </router-link>
              </li>
              <li
                class="submenu submenu-md dropend"
                :class="{ show: openSubmenu === 'party' }"
              >
                <a
                  class="dropdown-item dropdown-toggle"
                  role="button"
                  :aria-expanded="openSubmenu === 'party'"
                  @click.prevent.stop="toggleSubmenu('party')"
                >
                  Party
                </a>
                <ul
                  class="dropdown-menu dropdown-menu-dark"
                  :class="{ show: openSubmenu === 'party' }"
                >
                  <li>
                    <router-link
                      class="dropdown-item"
                      :to="partyKillsTarget"
                      @click="handleMenuAction"
                    >
                      Kills
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item"
                      :to="partyRollsTarget"
                      @click="handleMenuAction"
                    >
                      Rolls
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item"
                      :to="partyRunesTarget"
                      @click="handleMenuAction"
                    >
                      Runes
                    </router-link>
                  </li>
                </ul>
              </li>
              <li
                class="submenu submenu-md dropend"
                :class="{ show: openSubmenu === 'about' }"
              >
                <a
                  class="dropdown-item dropdown-toggle"
                  role="button"
                  :aria-expanded="openSubmenu === 'about'"
                  @click.prevent.stop="toggleSubmenu('about')"
                >
                  About
                </a>
                <ul
                  class="dropdown-menu dropdown-menu-dark"
                  :class="{ show: openSubmenu === 'about' }"
                >
                  <li>
                    <a class="dropdown-item">{{ getVersion }}</a>
                  </li>
                </ul>
              </li>
              <div class="dropdown-divider"></div>
              <li>
                <router-link
                  class="dropdown-item"
                  :to="{ name: 'logoutView' }"
                  @click="handleMenuAction"
                >
                  Logout
                </router-link>
              </li>
            </ul>
          </li>
          <!-- avatar -->
          <li class="nav-item me-3">
            <span class="d-inline-block">
              <img
                v-bind:src="avatar_image"
                height="70"
                width="70"
                class="rounded-circle bb-img"
                alt="Avatar"
              />
            </span>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
// --------
// scripts
//---------
import { mapGetters } from 'vuex'
import buildCampaignPopupTarget from '../helpers/buildCampaignPopupTarget'
export default {
  name: 'CharacterNavbar',
  props: {
    character: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      arena_name: '',
      arena_slug: '',
      openSubmenu: null,
    }
  },
  computed: {
    ...mapGetters('auth', {
      userProfile: 'getUserProfile',
    }),
    ...mapGetters('combat', {
      campaign: 'getCampaign',
      getVersion: 'getVersion',
    }),
    userName() {
      return this.userProfile?.user_name || ''
    },
    avatar_image() {
      return this.userProfile?.avatar_image || ''
    },
    currentCampaignId() {
      return (
        this.character?.arena ||
        this.campaign?.id ||
        this.$route.query.arena_id ||
        ''
      )
    },
    currentCampaignSlug() {
      return (
        this.character?.arena_slug ||
        this.character?.campaign_slug ||
        this.campaign?.slug ||
        this.$route.params.slug ||
        this.$route.query.slug ||
        ''
      )
    },
    linkedCharacterCampaignId() {
      return this.character?.arena || ''
    },
    linkedCharacterCampaignSlug() {
      return this.character?.arena_slug || this.character?.campaign_slug || ''
    },
    houseRulesTarget() {
      return buildCampaignPopupTarget({
        route: this.$route,
        popup: 'house-rules',
        arenaId: this.currentCampaignId,
        slug: this.currentCampaignSlug,
      })
    },
    partyRunesTarget() {
      return buildCampaignPopupTarget({
        route: this.$route,
        popup: 'party-runes',
        arenaId: this.linkedCharacterCampaignId,
        slug: this.linkedCharacterCampaignSlug,
      })
    },
    partyRollsTarget() {
      return buildCampaignPopupTarget({
        route: this.$route,
        popup: 'party-rolls',
        arenaId: this.linkedCharacterCampaignId,
        slug: this.linkedCharacterCampaignSlug,
      })
    },
    partyKillsTarget() {
      return buildCampaignPopupTarget({
        route: this.$route,
        popup: 'party-kills',
        arenaId: this.linkedCharacterCampaignId,
        slug: this.linkedCharacterCampaignSlug,
      })
    },
  },
  //---------
  // methods
  //---------
  methods: {
    toggleSubmenu(name) {
      this.openSubmenu = this.openSubmenu === name ? null : name
    },
    resetSubmenus() {
      this.openSubmenu = null
    },
    handleMenuAction() {
      this.resetSubmenus()
    },
    getCampaignHandler() {
      let campaign = this.campaign
      if (!campaign) {
        this.arena_name = ''
        this.arena_slug = ''
        return
      }
      this.arena_name = campaign.name
      this.arena_slug = campaign.slug
    },
  },
  //---------
  // mounted
  //---------
  mounted() {
    this.getCampaignHandler()
  },
}
</script>

<style scoped>
.bb-navbar {
  position: relative;
  z-index: 2600;
}

.bb-navbar .dropdown-menu {
  z-index: 2601;
}

.submenu {
  position: relative;
}

.submenu > .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
</style>
